import { useState } from "react";
import { RetroButtonContainer, RetroButtonInner, RetroButtonWrapper } from "./styled";

interface RetroButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "white" | "dark" | "disabled" | "green" | "red";
  shouldBounce?: boolean;
  disabled?: boolean;
  animationDuration?: number;
  size?: "sm" | "md";
  sx?: React.CSSProperties;
}

const RetroButton = ({
  sx,
  children,
  variant = "primary",
  size = "md",
  shouldBounce = true,
  disabled = false,
  animationDuration = 200,
  ...props
}: RetroButtonProps) => {
  const [isClicking, setIsClicking] = useState(false);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (disabled) return;
    setIsClicking(true);
    setTimeout(() => {
      props.onClick?.(e);
      if (shouldBounce) {
        setIsClicking(false);
      }
    }, animationDuration);
  };

  return (
    <RetroButtonWrapper size={size} sx={sx}>
      <RetroButtonContainer variant={variant} disabled={disabled} size={size}>
        <RetroButtonInner
          as="button"
          animationDuration={animationDuration}
          variant={variant}
          onClick={handleClick}
          isClicking={isClicking}
          disabled={disabled}
          size={size}>
          {children}
        </RetroButtonInner>
      </RetroButtonContainer>
    </RetroButtonWrapper>
  );
};

export { RetroButton, type RetroButtonProps };
